const organization = {
    require_membership: '사용자는 조직의 구성원이어야 합니다.',
};
export default Object.freeze(organization);
